export default __webpack_public_path__ + "static/teamsImg1-84d204aceb28a9d4f4710ad5c8dc5c1f.webp";